import { useContext } from 'react';
import useAppDispatch from 'hooks/useAppDispatch';
import { PropertyBusinessType } from 'models/Properties';
import {
  addVisibleProperties,
  removeVisibleProperties,
} from 'store/slices/stackedCalendar';
import ArrowRight from 'components/icons/ArrowRight';
import ArrowDown from 'components/icons/ArrowDown';
import CalendarContext from '../CalendarContext';
import useStackedCalendarVisibleProperties from '../useStackedCalendarVisibleProperties';
import { PropertyExpandArrowWrapper } from './PropertiesList.styles';
import usePersistentPropertyExpansion from './usePersistentPropertyExpansion';

const PropertyListItemExpandIcon = ({ uid }: { uid: string }) => {
  const { propertiesMap } = useContext(CalendarContext);
  const visibleProperties = useStackedCalendarVisibleProperties();
  const dispatch = useAppDispatch();
  const { togglePropertyExpansion, isExpanded } =
    usePersistentPropertyExpansion(uid);

  const { subUnits, unitTypes, businessType, units } = propertiesMap[uid];
  const subUnitUids = subUnits?.map(
    ({ uid: subUnitUid }) => `${subUnitUid}[SUB_UNIT]`,
  );

  const isHotel = businessType === PropertyBusinessType.HOTEL;
  const isUnitType = businessType === PropertyBusinessType.UNIT_TYPE;

  const toggleExpand = () => {
    const propertiesToChange = [];

    if (isHotel && isExpanded) {
      // @ts-expect-error TS2769 [STRICT-MIGRATION] Temporarily suppressing strict type checking - should be fixed when this code is next modified
      const unitsUids = unitTypes?.reduce((acc, ut) => {
        return [...acc, ...(ut.units?.map((u) => `${u.uid}[UNIT]`) || [])];
      }, []);
      // @ts-expect-error TS2461 [STRICT-MIGRATION] Temporarily suppressing strict type checking - should be fixed when this code is next modified
      propertiesToChange.push(...unitsUids);
    }

    if (isHotel) {
      const unitTypeUids = unitTypes?.map((ut) => `${ut.uid}[UNIT_TYPE]`);
      // @ts-expect-error TS2461 [STRICT-MIGRATION] Temporarily suppressing strict type checking - should be fixed when this code is next modified
      propertiesToChange.push(...unitTypeUids);
    } else if (isUnitType) {
      const unitsUids = units?.map((u) => `${u.uid}[UNIT]`);
      propertiesToChange.push(...unitsUids);
    } else {
      propertiesToChange.push(...subUnitUids);
    }

    if (isExpanded) {
      dispatch(
        removeVisibleProperties({
          properties: propertiesToChange,
        }),
      );
    } else {
      dispatch(
        addVisibleProperties({
          properties: propertiesToChange,
          index: visibleProperties.indexOf(`${uid}[${businessType}]`) + 1,
        }),
      );
    }

    togglePropertyExpansion();
  };

  const arrow = isExpanded ? <ArrowDown /> : <ArrowRight />;

  return (
    <PropertyExpandArrowWrapper onClick={toggleExpand}>
      {arrow}
    </PropertyExpandArrowWrapper>
  );
};

export default PropertyListItemExpandIcon;
